
import { INTERNAL_CHAT_CONTACTS, IS_LOADING } from '../../../../helpers/internalChatConstants';
import { buildLocalAttachments, internalChatMessageObject } from '../internalChatMessageObject';
import { generateDarkColorFromString } from '../../../../utils/generateColorBasedOnString';
import { messagesService } from '../../../../newServices/corporateChat';
import { normalizeArray } from '../../../../utils/normalizeArray';
import { getLastMessagePreview } from '../../../../utils/internalAttachments';
import { uuidv4 } from '../../../../utils/uuidGenerator';

export const toggleLoading = (isLoading) => {
    return {
        type: IS_LOADING,
        data: isLoading
    }
}

export const createOrUpdateContactObject = (contacts, { selectedUsers, messages, files }) => {
    const noAffectedContacts = contacts.filter(contact => !selectedUsers.some(user => user.id === contact.id));

    /** A conversa pode ser iniciada só com anexo: nesse caso não há mensagem para ler,
     *  então a data é a de agora e o preview cai no nome do primeiro arquivo.
     */
    const lastMessage = messages[messages.length - 1] || null;
    const dateLastMessage = lastMessage ? lastMessage.createdAt : new Date();
    /** `files` são objetos `File` do DOM (que expõem `.name`), e não anexos da API
     *  (`.fileName`) — sem converter, o preview da conversa nova ficaria em branco.
     */
    const lastMessagePreview = getLastMessagePreview(
        lastMessage && lastMessage.messageText,
        buildLocalAttachments(files)
    );

    /** Os anexos vão junto da última mensagem da fila, que é como a API os associa. */
    const messagesWithFiles = messages.map((message, index) => ({
        ...message,
        files: index === messages.length - 1 ? files : null
    }));

    const createOrUpdateArray = selectedUsers.map(contact => {
        const existingContact = contacts.find(c => c.id === contact.id);
        if (existingContact) {
            return {
                ...existingContact,
                color: generateDarkColorFromString(contact.email),
                dateLastMessage: dateLastMessage,
                lastMessage: lastMessagePreview,
                isAnExistingContact: true,
                messages: [
                    ...existingContact.messages,
                    ...messagesWithFiles.map((message, index) => {
                        return {
                            ...internalChatMessageObject(contact, message),
                            index: index
                        }
                    })
                ]
            }
        } else {
            return {
                ...contact,
                totalUnread: 0,
                color: generateDarkColorFromString(contact.email),
                createdAt: new Date(),
                dateLastMessage: dateLastMessage,
                lastMessage: lastMessagePreview,
                isAnExistingContact: false,
                messages: []
            }
        }
    })

    return {
        newContacts: createOrUpdateArray.filter(contact => !contact.isAnExistingContact),
        updatedContacts: createOrUpdateArray.filter(contact => contact.isAnExistingContact),
        noAffectedContacts: noAffectedContacts
    }
}

export const createOrUpdateContact = (contacts, requestData) => {
    return {
        type: INTERNAL_CHAT_CONTACTS,
        contacts: contacts.map(contact => {
            const existingContact = requestData.find(c => c.toUserId === contact.userId);
            /** Atualiza o ID da conversa. Esse ID é necessário, para algumas requisições,
             *  como, por exemplo, requisição de finalização de uma conversa.
             */
            if (typeof existingContact !== "undefined" && existingContact.toUserId === contact.userId) {
                contact.id = existingContact.conversationId;
            }
            return contact
        }),
        userStatus: normalizeArray({
            entity: 'byUserId',
            key: 'userId',
            array: contacts.map( user => {
                return {
                  userId: user.userId,
                  lastMessageStatusType: user.lastMessageStatusType,
                  loggedUserStatus: user.loggedUserStatus,
                  pause: user.pause
                } 
            })
        })
    };
}

export const sendMessagesToUsers = (contatcs, messages, files) => {
    /** A conversa pode ser iniciada só com anexo, mas a API exige ao menos uma
     *  mensagem: nesse caso vai uma entrada sem texto, como no envio dentro da conversa.
     *  O `order` é reindexado aqui porque o `message.id` do wizard é `messages.length + 1`
     *  no momento da criação — apagar uma mensagem do meio faria duas irem com o mesmo valor.
     */
    const messagesToSend = messages.length > 0
        ? messages.map((message, index) => ({
            order: index,
            messageText: message.messageText,
            externalReference: message.externalReference
        }))
        : [{ order: 0, messageText: '', externalReference: uuidv4() }];

    return messagesService.postMessagesSend({
        usersDestination: contatcs.map(contact => contact.id),
        messages: messagesToSend,
        files: files
    })
        .then(res => res)
        .catch(error => error);
}